import React, { useEffect, useRef, useState } from 'react'
import moment from 'moment'
import 'moment/locale/ja'
import Constants from '../../common/components/constants.jsx'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faImage } from '@fortawesome/free-solid-svg-icons'
import Sortable from 'react-sortablejs'

import '../../sass/topics.scss'
import { Box, Chip, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

export const TopicsRow = (props) => {
    const listRef = useRef()

    const [items, setItems] = useState(props.items);
    const [showPatrol, setShowPatrol] = useState(props.showPatrol);

    useEffect(() => {
      setItems(props.items);
      setShowPatrol(props.showPatrol);
    }, [props]);
  
    const handleStart = (evt) => {
      console.log(evt);
    };
  
    const handleEnd = (evt) => {
      console.log(evt);
      console.log(items);
      updateSortItems();
    };
  
    const handleAdd = (evt) => {
      console.log(evt);
    };
  
    const handleUpdate = (evt) => {
      console.log(evt);
    };
  
    const handleRemove = (evt) => {
      console.log(evt);
    };
  
    const handleSort = (evt) => {
      console.log(evt);
    };
  
    const handleFilter = (evt) => {
      console.log(evt);
    };
  
    const updateSortItems = () => {
      console.log(items);
      props.updateSortItems(items);
    };
  
    const editTopics = (item) => {
      props.editTopics(item);
    };
  
    const deleteTopic = (item) => {
      props.deleteTopic(item);
    };
  
    const patrolTopic = (item) => {
      props.patrolTopic(item);
    };
  
    const dateTimeComponent = (str) => {
      const parts = str.split(' ');
      return (
        <div className="date_time">
          <span className="date">{parts[0]}</span>
          <span className="time">{parts[1]}</span>
        </div>
      );
    };
  
    const edit_autorized = (
        props.auth.hasOwnProperty('role') &&
        props.auth.role.hasOwnProperty('EDIT_TOPIC') &&
        props.auth.role.EDIT_TOPIC
    );
    const delete_autorized = (
        props.auth.hasOwnProperty('role') &&
        props.auth.role.hasOwnProperty('DELETE_TOPIC') &&
        props.auth.role.DELETE_TOPIC
    );
    const patrol_autorized = (
        props.auth.hasOwnProperty('role') &&
        props.auth.role.hasOwnProperty('PATROL_TOPIC') &&
        props.auth.role.PATROL_TOPIC
    );

    const itemsList = items.map((item, index) => {
      // 画像添付がある場合アイコンを追加
      let attach;
      if (item.MEDIAS.length) {
        attach = (
          <div className="attach">
            <FontAwesomeIcon size="2x" icon={faImage} className={"far"} color={"gray"} />
          </div>
        );
      }
      // 配信状態のステータス
      let castStatus;
      switch (item.CAST_STATUS) {
        case 0:
          castStatus = (<Chip size={"small"} label={"配信中"} color="primary" />);
          break;
        case 1:
          castStatus = (<Chip size={"small"} label={"配信前"} />);
          break;
        case 2:
          castStatus = (<Chip size={"small"} label={"配信終了"} color="secondary" />);
          break;
        default:
          castStatus = (<Chip size={"small"} label={"不明"} />);
      }
      // 検閲状態のステータス
      let patrollStatus;
      switch (item.PATROLLED) {
        case 'NOTYET':
          patrollStatus = (<Chip size={"small"} label={"未確認"} />);
          break;
        case 'ACCEPTED':
          patrollStatus = (<Chip size={"small"} label={"承認"} color={"primary"} />);
          break;
        case 'REJECTED':
          patrollStatus = (<Chip size={"small"} label={"却下"} color={"secondary"} />);
          break;
        case 'AUTO_ACCEPTED':
          patrollStatus = (<Chip size={"small"} label={"自動承認"} color={"primary"} />);
          break;
        default:
          patrollStatus = (<Chip size={"small"} label={"不明"} color={"secondary"} />);
      }
  
      let editTh;
      let deleteTh;
  
      if (edit_autorized) {
        editTh = (
          <Tooltip title="編集" aria-label="edit">
            <IconButton
              aria-label="edit"
              className="edit"
              size={"small"}
              onClick={() => { editTopics(item); }}
            >
              <EditIcon />
            </IconButton>
          </Tooltip>
        );
      } else if (patrol_autorized) {
        editTh = (
          <Tooltip title="承認" aria-label="edit">
            <IconButton
              aria-label="edit"
              className="edit"
              size={"small"}
              onClick={() => { patrolTopic(item); }}
            >
              <CheckBoxIcon />
            </IconButton>
          </Tooltip>
        );
      }
  
      if (delete_autorized) {
        deleteTh = (
          <Tooltip title="削除" aria-label="delete">
            <IconButton
              aria-label="delete"
              className="delete"
              size={"small"}
              onClick={() => { deleteTopic(item); }}
            >
              <DeleteForeverIcon />
            </IconButton>
          </Tooltip>
        );
      }
  
      return (
        <TableRow key={index}>
          <TableCell className="index">{index + 1}</TableCell>
          <TableCell>{castStatus}</TableCell>
          <TableCell className="statuses">{patrollStatus}</TableCell>
          <TableCell className="title">{item.TOPIC_TITLE}</TableCell>
          <TableCell>{attach}</TableCell>
          <TableCell className="available">
            開始: {moment(item.TOPIC_AVAILABLE_FROM).format("YYYY-MM-DD HH:mm")}<br />
            終了: {moment(item.TOPIC_AVAILABLE_TO).format("YYYY-MM-DD HH:mm")}
          </TableCell>
          <TableCell className="created">{moment(item.TOPIC_CREATED).format("YYYY-MM-DD HH:mm")}</TableCell>
          <TableCell>{item.TOPIC_AUTHOR_NAME}</TableCell>
          <TableCell align="right">
            {editTh}
            {deleteTh}
          </TableCell>
        </TableRow>
      );
    });
  
    return (
      <div ref={listRef}>
      <ul className="topics-list" >
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
          <TableContainer sx={{ maxHeight: window.innerHeight }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell width={60} sx={{ background: "#f8f8f8" }}><Typography fontWeight="540">No</Typography></TableCell>
                  <TableCell width={120} sx={{ background: "#f8f8f8" }}>配信状況</TableCell>
                  <TableCell width={80} sx={{ background: "#f8f8f8" }}>承認</TableCell>
                  <TableCell width={600} sx={{ background: "#f8f8f8" }}>タイトル</TableCell>
                  <TableCell width={80} sx={{ background: "#f8f8f8" }}></TableCell>
                  <TableCell width={200} sx={{ background: "#f8f8f8" }}>配信日程</TableCell>
                  <TableCell width={150} sx={{ background: "#f8f8f8" }}>作成日時</TableCell>
                  <TableCell width={200} sx={{ background: "#f8f8f8" }}>作成者</TableCell>
                  <TableCell width={20} sx={{ background: "#f8f8f8" }}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {itemsList}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </ul>
      </div>
    );
  };

TopicsRow.defaultProps = {
    items: [],
    showPatrol: false,
};

// const sortableOptions = {
//     model: 'items',
//     animation: 150,
//     ghostClass: "sortable-ghost",  // Class name for the drop placeholder
//     chosenClass: "sortable-chosen"
// };
// export default Sortable(sortableOptions)(TopicsRow)
  
export default TopicsRow;